export const PYTHON_API_URL = 'https://aiengine.medinotex.ai';
export const AZURE_CONFIG = {
  serviceRegion: 'centralindia',
  speechKey: '9983bf468836479f8ab7db2b780bcc56',
  speechRecognitionLanguage: 'en-US'
};